import { render, staticRenderFns } from "./InventorySubMenuCalendar.vue?vue&type=template&id=27b8d0bb&scoped=true&"
import script from "./InventorySubMenuCalendar.vue?vue&type=script&lang=js&"
export * from "./InventorySubMenuCalendar.vue?vue&type=script&lang=js&"
import style0 from "./InventorySubMenuCalendar.vue?vue&type=style&index=0&id=27b8d0bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b8d0bb",
  null
  
)

export default component.exports